import Client from './instance/client'

const wda = {
  Client
}

export default wda